/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qk_ParentInputs */

const en_qk_parent = /** @type {(inputs: Qk_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parent key`)
};

const de_qk_parent = /** @type {(inputs: Qk_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel des übergeordneten Vorgangs`)
};

/**
* | output |
* | --- |
* | "Parent key" |
*
* @param {Qk_ParentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const qk_parent = /** @type {((inputs?: Qk_ParentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qk_ParentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_qk_parent(inputs)
	return en_qk_parent(inputs)
});